import styled from 'styled-components';

export const QrCodeContainer = styled.div`
    display: flex;
    flex-direction: column;

    .download-qr-button {
        padding-left: 0;
        padding-right: 0;
    }
`;
